import { z } from 'zod';
import { msg, translate } from '@/lib/forms/messages';
import { maxCodePoints } from '@/lib/forms/primitives';

// Mirrors database/migrations/038_gds_drbfm_case_workflow.sql:10-13 NOT NULL columns and
// :30-32 length CHECKs; CreateCaseRequest (api/routes/drbfm.py:314-321) is bare `str`, no length.
// Postgres LENGTH() counts code points — hence maxCodePoints, not `.length`.

// Thunk: i18next expands `$t()` only in resource strings, not interpolation values.
// Message is the drbfm.case.required key in both locale bundles, interpolating {{field}}.
const requiredWithLabel = (labelKey: string) =>
  msg('drbfm.case.required', () => ({ field: translate(labelKey) }));

export const caseIntakeSchema = z.object({
  title: z
    .string()
    .trim()
    .min(1, requiredWithLabel('drbfm.case.fields.title'))
    .check(maxCodePoints(500, 'validation.maxLength')),
  productName: z
    .string()
    .trim()
    .min(1, requiredWithLabel('drbfm.case.fields.productName'))
    .check(maxCodePoints(300, 'validation.maxLength')),
  targetPart: z
    .string()
    .trim()
    .min(1, requiredWithLabel('drbfm.case.fields.targetPart'))
    .check(maxCodePoints(300, 'validation.maxLength')),
  // change_summary is TEXT with no CHECK (038:13) — required but deliberately uncapped.
  changeSummary: z
    .string()
    .trim()
    .min(1, requiredWithLabel('drbfm.case.fields.changeSummary')),
});

export type CaseIntakeFormValues = z.infer<typeof caseIntakeSchema>;
